import React, { useEffect } from 'react';
import { FaCheck } from 'react-icons/fa6';
import { RxCross2 } from 'react-icons/rx';
import './ComparisonTable.css';

const ComparisonTable = (props) => {
    // Define plans configuration
    const { comparisonData, subscriptionList } = props

    const [containerWidth, setContainerWidth] = React.useState("1450px");

    useEffect(() => {
        if (subscriptionList?.length)

            if (subscriptionList?.length == 4) {
                setContainerWidth("1450px");

            } else {
                setContainerWidth("1200px");

            }
    }, [subscriptionList])

    const plansConfig = [
        { key: 'free_detail', name: 'FREE', badge: 'FREE', badgeClass: 'badge-free' },
        { key: 'basic_detail', name: 'BASIC', badge: 'BASIC', badgeClass: 'badge-basic' },
        { key: 'premium_detail', name: 'PREMIUM', badge: 'PREMIUM', badgeClass: 'badge-premium' },
        { key: 'premium_plus_detail', name: 'PREMIUM+', badge: 'PREMIUM+', badgeClass: 'badge-premium-plus' },
        { key: 'entreprise', name: 'ENTERPRISE', badge: 'ENTERPRISE', badgeClass: 'badge-enterprise' }
    ];

    // Transform JSON data into features array
    const transformData = () => {
        const allFeatures = [];

        comparisonData?.forEach(category => {
            // Add category header


            // Add features for this category
            category.features.forEach(feature => {
                const featureRow = {
                    name: feature.name,
                    values: plansConfig.map(plan => feature[plan.key])
                };
                allFeatures.push(featureRow);
            });
        });

        return allFeatures;
    };

    const features = transformData();
 

    const renderValue = (value) => {
        if (!value) return <span className="cross-icon"><RxCross2 /></span>;

        // Handle checkmark symbols
        if (value === '✔' || value === true) {
            return <span className="check-icon"><FaCheck /></span>;
        }
        // Handle cross symbols
        else if (value === '✖' || value === '✖ ' || value === false) {
            return <span className="cross-icon"><RxCross2 /></span>;
        }
        // Handle special text
        else if (value === 'swipe') {
            return <span className="swipe-text">swipe —</span>;
        }
        // Handle all other text values
        else {
            return <span className="custom-text">{value}</span>;
        }
    };

    return (
        <div className="comparison-table-wrapper" style={{ maxWidth: containerWidth }}>
            <h2 className="comparison-title">Compare Plans & Features</h2>

            <div className="comparison-table-container">
                <table className="comparison-table">
                    <thead>
                        <tr>
                            <th className="feature-column">Features</th>
                            {plansConfig?.map((plan, index) => (
                                <th key={index} className="plan-column">
                                    <span className={`plan-badge ${plan?.badgeClass}`}>
                                        {plan?.badge}
                                    </span>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {features?.map((feature, index) => (
                            <tr key={index}>
                                <td className="feature-name">{feature?.name}</td>
                                {feature?.values?.map((value, idx) => (
                                    <td key={idx} className="feature-value">
                                        {renderValue(value)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ComparisonTable;